import { LAYER_TYPES, PROP_DATA_TYPE, GEOJSON_GEOMETRIES } from '../../../../api/Layers/Layers';

export default [
  {
    name: 'Join Example',
    geojsonId: 'Spain Provinces',
    geojsonPropToJoin: 'cod_prov',
    thematicId: 'CSV Example For Fusion',
    thematicKeyToJoin: 'cod_prov',
    layerType: LAYER_TYPES.JOIN,
    geojsonProps: [
      {
        name: 'cod_prov',
        max: '52',
        min: '01',
        dataType: PROP_DATA_TYPE.STRING
      },
      {
        name: 'name',
        max: 'Ávila',
        min: 'A Coruña',
        dataType: PROP_DATA_TYPE.STRING
      },
      {
        name: 'cod_ccaa',
        max: '19',
        min: '01',
        dataType: PROP_DATA_TYPE.STRING
      },
      {
        name: 'cartodb_id',
        max: 52,
        min: 1,
        dataType: PROP_DATA_TYPE.NUMBER
      },
      {
        name: 'created_at',
        max: '2014-09-30T00:00:00Z',
        min: '2014-09-30T00:00:00Z',
        dataType: PROP_DATA_TYPE.STRING
      },
      {
        name: 'updated_at',
        max: '2014-12-25T01:56:10Z',
        min: '2014-12-25T01:56:10Z',
        dataType: PROP_DATA_TYPE.STRING
      },
      { name: 'atributoA', max: 100, min: 3, dataType: PROP_DATA_TYPE.NUMBER },
      { name: 'atributoB', max: 50, min: -50, dataType: PROP_DATA_TYPE.NUMBER },
      { name: 'atributoC', max: 'value3', min: 'value1', dataType: PROP_DATA_TYPE.STRING }
    ],
    geojsonGeometry: GEOJSON_GEOMETRIES.POLYGON,
    styleId: 'Simple Orange Polygon'
  }
];
